module.exports = __webpack_public_path__ + "media/images/lb/913-cfe918a39e477642193902080d981c7c.svg";